(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var openTriggers = document.querySelectorAll('[data-cart-drawer-open]');
    var closeTriggers = drawer.querySelectorAll('[data-cart-drawer-close]');
    var itemsContainer = drawer.querySelector('[data-cart-items]');
    var emptyState = drawer.querySelector('[data-cart-empty]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var cartBags = document.querySelectorAll('[data-cart-bag]');
    var qtyLabel = drawer.dataset.cartQtyLabel || '';
    var removeLabel = drawer.dataset.cartRemoveLabel || '';
    var removeTemplate = drawer.querySelector('[data-cart-remove-template]');
    var removeIcon = removeTemplate ? removeTemplate.innerHTML : '';

    function openDrawer() {
      drawer.classList.remove('is-closing');
      // Force reflow to ensure animation plays
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.add('is-closing');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';

      // Remove closing class after animation completes
      setTimeout(function() {
        drawer.classList.remove('is-closing');
      }, 400);
    }

    openTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    closeTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        // For overlay, only close if clicking directly on it
        // For close button, always close
        if (trigger.classList.contains('cart-drawer__overlay')) {
          if (e.target === trigger) {
            closeDrawer();
          }
        } else {
          closeDrawer();
        }
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Quantity change handling
    drawer.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quantity-change]');
      if (!btn || !drawer.contains(btn)) return;

      var line = btn.dataset.line;
      var quantity = parseInt(btn.dataset.quantity, 10);
      var itemEl = btn.closest('.cart-drawer__item');

      if (quantity === 0 && itemEl) {
        if (itemEl.classList.contains('is-removing')) return;
        itemEl.classList.add('is-removing');

        window.setTimeout(function() {
          updateCartQuantity(line, quantity, itemEl);
        }, 280);

        return;
      }

      updateCartQuantity(line, quantity, null);
    });

    function getDrawerStockLimitMessage(maxQuantity) {
      var cappedQuantity = Math.max(parseInt(maxQuantity, 10) || 0, 0);
      return 'Only ' + cappedQuantity + ' item was added to your cart due to availability.';
    }

    function getItemErrorEl(line) {
      return drawer.querySelector('.cart-drawer__item-error[data-line="' + line + '"]');
    }

    function showItemError(line, message) {
      var errorEl = getItemErrorEl(line);
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearItemError(line) {
      var errorEl = getItemErrorEl(line);
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function updateCartQuantity(line, quantity, sourceItemEl) {
      if (!line || isNaN(quantity)) return;
      clearItemError(line);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(error) {
            var message = error && (error.description || error.message)
              ? (error.description || error.message)
              : 'Unable to update quantity';
            throw new Error(message);
          }, function() {
            throw new Error('Unable to update quantity');
          });
        }
        return response.json();
      })
      .then(function(cart) {
        var normalizedLine = parseInt(line, 10);
        var lineItem = !isNaN(normalizedLine) && normalizedLine > 0
          ? cart.items[normalizedLine - 1]
          : null;
        var lineError = '';

        if (quantity > 0 && lineItem && quantity > lineItem.quantity) {
          lineError = getDrawerStockLimitMessage(lineItem.quantity);
        }

        renderCartDrawer(cart);

        if (lineError) {
          showItemError(line, lineError);
        }
      })
      .catch(function(error) {
        if (sourceItemEl) {
          sourceItemEl.classList.remove('is-removing');
        }
        showItemError(line, error.message || 'Unable to update quantity');
        console.error('Error updating cart:', error);
      });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }

    function renderCartDrawer(cart, animate) {
      if (!itemsContainer || !emptyState) return;

      updateHeaderCartCount(cart.item_count, animate);

      if (cart.item_count === 0) {
        itemsContainer.hidden = true;
        emptyState.hidden = false;
        if (footer) footer.hidden = true;
      } else {
        itemsContainer.hidden = false;
        emptyState.hidden = true;
        if (footer) footer.hidden = false;
      }

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price);
      }

      itemsContainer.innerHTML = cart.items.map(function(item, index) {
        var imageHtml = '';
        if (item.image) {
          imageHtml = '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title || '') + '" loading="lazy">';
        } else {
          imageHtml = '{{ "product-1" | placeholder_svg_tag | strip_newlines | replace: "\"", "\\\"" }}';
        }

        var variantsHtml = '';
        if (item.options_with_values && item.options_with_values.length > 0) {
          variantsHtml = '<div class="cart-drawer__item-variants">' + item.options_with_values.map(function(option) {
            return '<span class="cart-drawer__item-variant">' + escapeHtml(String(option.name).toUpperCase()) + ': ' + escapeHtml(option.value) + '</span>';
          }).join('') + '</div>';
        }

        return (
          '<div class="cart-drawer__item" data-cart-item data-line-id="' + item.key + '">' +
            '<a href="' + item.url + '" class="cart-drawer__item-image">' +
              imageHtml +
            '</a>' +
            '<div class="cart-drawer__item-details">' +
              '<div class="cart-drawer__item-header">' +
                '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title || item.title || '') + '</a>' +
                '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              variantsHtml +
              '<div class="cart-drawer__item-quantity">' +
                '<span class="cart-drawer__item-quantity-label">' + escapeHtml(qtyLabel) + ':</span>' +
                '<div class="cart-drawer__quantity-selector">' +
                  '<button type="button" class="cart-drawer__quantity-btn" data-quantity-change data-line="' + (index + 1) + '" data-quantity="' + Math.max(item.quantity - 1, 0) + '" aria-label="' + escapeHtml(qtyLabel) + '">−</button>' +
                  '<span class="cart-drawer__quantity-value">' + item.quantity + '</span>' +
                  '<button type="button" class="cart-drawer__quantity-btn" data-quantity-change data-line="' + (index + 1) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(qtyLabel) + '">+</button>' +
                '</div>' +
              '</div>' +
              '<p class="cart-drawer__item-error" data-line="' + (index + 1) + '" hidden></p>' +
              '<div class="cart-drawer__item-actions">' +
                '<button type="button" class="cart-drawer__item-remove" data-quantity-change data-line="' + (index + 1) + '" data-quantity="0">' + (removeIcon || escapeHtml(removeLabel)) + '</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function updateHeaderCartCount(count, animate) {
      cartBags.forEach(function(bag) {
        var countEl = bag.querySelector('[data-cart-count]');

        if (count > 0) {
          bag.classList.add('has-items');
          if (countEl) {
            countEl.textContent = count;
            countEl.hidden = false;
          }
        } else {
          bag.classList.remove('has-items');
          if (countEl) {
            countEl.textContent = '0';
            countEl.hidden = false;
          }
        }

        // Trigger bounce animation
        if (animate) {
          bag.classList.remove('is-animating');
          void bag.offsetWidth; // Force reflow
          bag.classList.add('is-animating');
          setTimeout(function() {
            bag.classList.remove('is-animating');
          }, 500);
        }
      });
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    // Listen for custom event to open drawer (for add to cart)
    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cart:updated', function(e) {
      if (!e.detail || typeof e.detail.item_count !== 'number') return;
      var shouldAnimate = e.detail.animate === true;
      renderCartDrawer(e.detail, shouldAnimate);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["connect-social-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('[data-connect-social-drawer]');
    if (!root) return;
    if (root.dataset.connectSocialInit === 'true') return;
    root.dataset.connectSocialInit = 'true';

    var sheet = root.querySelector('[data-connect-social-sheet]');
    var panel = root.querySelector('[data-connect-social-panel]');
    var closeButtons = root.querySelectorAll('[data-connect-social-close]');
    var delaySeconds = parseFloat(root.dataset.delaySeconds);
    var autoDismissSeconds = parseFloat(root.dataset.autoDismissSeconds);
    var hideForSession = root.dataset.hideForSession === 'true';
    var designMode = root.dataset.designMode === 'true';
    var dismissKey = root.dataset.dismissKey || 'connect-social-drawer-dismissed-v1';
    var shownKey = root.dataset.shownKey || 'connect-social-drawer-shown-v1';
    var startKey = root.dataset.startKey || 'connect-social-drawer-started-at-v1';
    var autoOpenTimer = null;
    var autoDismissTimer = null;

    if (isNaN(delaySeconds) || delaySeconds < 0) {
      delaySeconds = 20;
    }

    if (isNaN(autoDismissSeconds) || autoDismissSeconds < 0) {
      autoDismissSeconds = 12;
    }

    function readSessionStorage(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function writeSessionStorage(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (error) {
        // Ignore session storage failures.
      }
    }

    function clearAutoOpenTimer() {
      if (autoOpenTimer) {
        window.clearTimeout(autoOpenTimer);
        autoOpenTimer = null;
      }
    }

    function isDismissed() {
      if (designMode) return false;
      if (!hideForSession) return false;
      return readSessionStorage(dismissKey) === 'true';
    }

    function isShown() {
      if (designMode) return false;
      return readSessionStorage(shownKey) === 'true';
    }

    function markShown() {
      if (designMode) return;
      writeSessionStorage(shownKey, 'true');
    }

    function dismissDrawer() {
      if (!designMode && hideForSession) {
        writeSessionStorage(dismissKey, 'true');
      }
      closeDrawer();
    }

    function clearAutoDismissTimer() {
      if (autoDismissTimer) {
        window.clearTimeout(autoDismissTimer);
        autoDismissTimer = null;
      }
    }

    function scheduleAutoDismiss() {
      clearAutoDismissTimer();
      if (autoDismissSeconds === 0) return;
      autoDismissTimer = window.setTimeout(closeDrawer, Math.round(autoDismissSeconds * 1000));
    }

    function openDrawer() {
      if (root.classList.contains('is-open')) return;

      root.classList.add('is-open');
      if (sheet) sheet.setAttribute('aria-hidden', 'false');
      if (panel) panel.setAttribute('tabindex', '-1');
      scheduleAutoDismiss();
    }

    function closeDrawer() {
      if (!root.classList.contains('is-open')) return;

      root.classList.remove('is-open');
      if (sheet) sheet.setAttribute('aria-hidden', 'true');
      clearAutoDismissTimer();
    }

    function newsletterDrawerOpen() {
      var newsletter = document.querySelector('[data-discount-newsletter]');
      if (!newsletter) return false;
      return newsletter.classList.contains('is-open');
    }

    function tryAutoOpen() {
      clearAutoOpenTimer();

      if (isDismissed()) return;
      if (isShown()) return;
      if (root.classList.contains('is-open')) return;

      if (newsletterDrawerOpen()) {
        autoOpenTimer = window.setTimeout(tryAutoOpen, 3000);
        return;
      }

      markShown();
      openDrawer();
    }

    function scheduleAutoOpen() {
      var delayMs = Math.round(delaySeconds * 1000);
      var startedAtRaw;
      var startedAt;
      var now;
      var remainingMs;

      if (isDismissed()) return;
      if (isShown()) return;

      if (designMode && delayMs === 0) {
        tryAutoOpen();
        return;
      }

      startedAtRaw = readSessionStorage(startKey);
      startedAt = startedAtRaw == null ? NaN : parseInt(startedAtRaw, 10);
      now = Date.now();

      if (designMode) {
        startedAt = now;
      } else if (isNaN(startedAt) || startedAt <= 0) {
        startedAt = now;
        writeSessionStorage(startKey, String(startedAt));
      }

      remainingMs = delayMs - Math.max(0, now - startedAt);

      if (remainingMs <= 0) {
        tryAutoOpen();
        return;
      }

      autoOpenTimer = window.setTimeout(tryAutoOpen, remainingMs);
    }

    if (panel) {
      /* Don't auto-dismiss out from under the user mid-interaction. */
      panel.addEventListener('mouseenter', clearAutoDismissTimer);
      panel.addEventListener('focusin', clearAutoDismissTimer);
      panel.addEventListener('mouseleave', function() {
        if (root.classList.contains('is-open')) scheduleAutoDismiss();
      });
      panel.addEventListener('focusout', function() {
        if (root.classList.contains('is-open') && !panel.contains(document.activeElement)) {
          scheduleAutoDismiss();
        }
      });
    }

    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        dismissDrawer();
      });
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        dismissDrawer();
      }
    });

    scheduleAutoOpen();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('[data-discount-newsletter]');
    if (!root) return;
    if (root.dataset.discountInitialized === 'true') return;
    root.dataset.discountInitialized = 'true';

    var sheet = root.querySelector('[data-discount-sheet]');
    var panel = root.querySelector('[data-discount-panel]');
    var form = root.querySelector('form');
    var discountCodeLink = root.querySelector('[data-discount-code-link]');
    var closeButtons = root.querySelectorAll('[data-discount-close]');
    var dismissButtons = root.querySelectorAll('[data-discount-dismiss]');
    var emailInput = root.querySelector('[data-discount-email]');
    var emailPreview = root.querySelector('[data-discount-email-preview]');
    var phoneInput = root.querySelector('[data-discount-phone]');
    var consentInput = root.querySelector('input[name="contact[accepts_marketing]"]');
    var syncDebugNode = root.querySelector('[data-discount-sync-debug]');
    var revealSubmitButton = root.querySelector('[data-discount-submit-reveal]');
    var skipSubmitButton = root.querySelector('[data-discount-submit-skip]');
    var revealErrorMessage = root.querySelector('[data-discount-reveal-error]');
    var submitActionField = root.querySelector('[data-discount-submit-action]');
    var successStateMarker = root.querySelector('[data-discount-success-state]');
    var stepOne = root.querySelector('[data-discount-step="1"]');
    var stepTwo = root.querySelector('[data-discount-step="2"]');
    var tabWrap = root.querySelector('[data-discount-tab]');
    var hasServerErrors = root.querySelector('[data-discount-has-errors][value="true"]') !== null;
    var delaySeconds = parseInt(root.dataset.delaySeconds, 10);
    var tabAutoHideSeconds = parseFloat(root.dataset.tabAutoHideSeconds);
    var isInstagramWebview = detectInstagramWebview();
    var cartPromptDelaySeconds = parseFloat(root.dataset.cartPromptDelaySeconds);
    var initialCartItemCount = parseInt(root.dataset.cartItemCount, 10);
    var dismissKey = root.dataset.dismissKey || 'discount-newsletter-dismissed';
    var hideForSession = root.dataset.hideForSession === 'true';
    var designMode = root.dataset.designMode === 'true';
    var isInstagramManualMode = isInstagramWebview && !designMode;
    var disableAutoPrompts = isInstagramManualMode;
    var phoneInvalidMessage = root.dataset.phoneInvalidMessage || 'Enter a valid phone number.';
    var backendEndpointUrl = (root.dataset.backendEndpointUrl || '').trim();
    var countryIso = (root.dataset.countryIso || 'US').toUpperCase();
    var revealNeedsPhoneMessage = 'Add your phone to unlock this code';
    var activeTrigger = null;
    var submitIntent = '';
    var tagAutoHideTimer = null;
    var cartPromptOpenTimer = null;
    var cartCountSyncTimer = null;
    var isCartPromptQueued = false;
    var scrollStorageKey = 'discount-newsletter-scroll-y';
    var pathStorageKey = 'discount-newsletter-origin-path';
    var tagAutoHiddenKey = 'discount-newsletter-tab-auto-hidden-v1';
    var cartPromptShownKey = 'discount-newsletter-cart-prompt-shown-v4';
    var cartPromptPendingKey = 'discount-newsletter-cart-prompt-pending-v3';
    var cartCountSessionKey = 'discount-newsletter-cart-count-v4';
    var backendSyncPayloadKey = 'discount-newsletter-backend-sync-payload-v1';
    var backendSyncLastSuccessKey = 'discount-newsletter-backend-sync-last-success-v1';
    var backendSyncDebugKey = 'discount-newsletter-backend-sync-debug-v1';
    var cartPromptDelayMs = 1400;
    var isBackendSyncRequestPending = false;
    var instagramManualOpenIntent = false;
    var instagramDockedTabClass = 'is-instagram-docked';
    var instagramTabHiddenClass = 'is-instagram-tab-hidden';
    var currentCartItemCount = isNaN(initialCartItemCount) ? 0 : initialCartItemCount;
    var storedCartCountRaw = readSessionStorage(cartCountSessionKey);
    var storedCartCount = storedCartCountRaw == null ? NaN : parseInt(storedCartCountRaw, 10);
    var hasStoredCartCount = !isNaN(storedCartCount);
    var lastKnownCartItemCount = hasStoredCartCount ? storedCartCount : currentCartItemCount;

    if (isInstagramWebview) {
      document.documentElement.classList.add('is-instagram-webview');
      document.documentElement.setAttribute('data-in-app-browser', 'instagram');
      if (tabWrap) {
        tabWrap.style.display = '';
        tabWrap.removeAttribute('hidden');
        tabWrap.removeAttribute('aria-hidden');
      }
    }

    if (isInstagramManualMode) {
      dockInstagramTab();
      hideInstagramDockedTab();
    }

    if (isNaN(delaySeconds) || delaySeconds < 0) {
      delaySeconds = 10;
    }

    if (isNaN(cartPromptDelaySeconds) || cartPromptDelaySeconds < 0) {
      cartPromptDelaySeconds = 1.4;
    }

    if (isNaN(tabAutoHideSeconds) || tabAutoHideSeconds < 0) {
      tabAutoHideSeconds = 10;
    }

    cartPromptDelayMs = Math.round(cartPromptDelaySeconds * 1000);

    function detectInstagramWebview() {
      var ua = (navigator.userAgent || '').toLowerCase();
      var referrer = (document.referrer || '').toLowerCase();

      if (document.documentElement.classList.contains('is-instagram-webview')) return true;
      if (ua.indexOf('instagram') !== -1 || ua.indexOf('fban/instagram') !== -1) return true;
      if (referrer.indexOf('l.instagram.com') !== -1 || referrer.indexOf('instagram.com') !== -1) return true;
      return false;
    }

    function dockInstagramTab() {
      if (!tabWrap) return;
      if (!document.body) return;
      if (!tabWrap.classList.contains(instagramDockedTabClass)) {
        tabWrap.classList.add(instagramDockedTabClass);
      }
      tabWrap.classList.remove(instagramTabHiddenClass);
      if (tabWrap.parentNode !== document.body) {
        document.body.appendChild(tabWrap);
      }
    }

    function hideInstagramDockedTab() {
      if (!isInstagramManualMode) return;
      if (!tabWrap || !tabWrap.classList.contains(instagramDockedTabClass)) return;
      tabWrap.classList.add(instagramTabHiddenClass);
    }

    function showInstagramDockedTab() {
      if (!isInstagramManualMode) return;
      if (!tabWrap || !tabWrap.classList.contains(instagramDockedTabClass)) return;
      tabWrap.classList.remove(instagramTabHiddenClass);
    }

    function readSessionStorage(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function readCookie(key) {
      var escapedKey;
      var match;

      if (typeof document === 'undefined' || typeof document.cookie !== 'string') return null;

      escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      match = document.cookie.match(new RegExp('(?:^|; )' + escapedKey + '=([^;]*)'));

      if (!match || typeof match[1] === 'undefined') return null;

      try {
        return decodeURIComponent(match[1]);
      } catch (error) {
        return match[1];
      }
    }

    function writeCookie(key, value, days) {
      var expires = '';
      var maxAgeDays = typeof days === 'number' ? days : 365;
      var expiresDate;

      try {
        expiresDate = new Date();
        expiresDate.setTime(expiresDate.getTime() + (maxAgeDays * 24 * 60 * 60 * 1000));
        expires = '; expires=' + expiresDate.toUTCString();
        document.cookie = key + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
      } catch (error) {
        // Ignore cookie write errors.
      }
    }

    function writeSessionStorage(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (error) {
        // Ignore storage errors.
      }
    }

    function readPersistentStorage(key) {
      var value = null;

      try {
        value = localStorage.getItem(key);
      } catch (error) {
        value = null;
      }

      if (value != null) return value;

      return readCookie(key);
    }

    function writePersistentStorage(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        // Ignore local storage errors.
      }

      writeCookie(key, value, 365);
    }

    function removeSessionStorage(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {
        // Ignore storage errors.
      }
    }

    function readJsonSessionStorage(key) {
      var rawValue;

      rawValue = readSessionStorage(key);
      if (!rawValue) return null;

      try {
        return JSON.parse(rawValue);
      } catch (error) {
        return null;
      }
    }

    function clearSyncDebugStatus() {
      if (syncDebugNode) {
        syncDebugNode.hidden = true;
        syncDebugNode.textContent = '';
        syncDebugNode.removeAttribute('data-tone');
      }

      removeSessionStorage(backendSyncDebugKey);
    }

    function writeSyncDebugStatus(message, tone) {
      var payload;

      if (!message) return;

      payload = {
        message: String(message),
        tone: tone || 'info',
        ts: Date.now()
      };

      if (syncDebugNode) {
        syncDebugNode.hidden = false;
        syncDebugNode.textContent = payload.message;
        syncDebugNode.setAttribute('data-tone', payload.tone);
      }

      try {
        writeSessionStorage(backendSyncDebugKey, JSON.stringify(payload));
      } catch (error) {
        // Ignore debug status storage errors.
      }
    }

    function restoreSyncDebugStatus() {
      var payload = readJsonSessionStorage(backendSyncDebugKey);

      if (!syncDebugNode) return;
      if (!payload || !payload.message) return;

      syncDebugNode.hidden = false;
      syncDebugNode.textContent = String(payload.message);
      syncDebugNode.setAttribute('data-tone', payload.tone || 'info');
    }

    function getBackendSyncCustomerNotice(resultData) {
      var messages = [];
      var combinedMessage = '';

      if (!resultData) return null;

      if (resultData.error) {
        messages.push(String(resultData.error));
      }

      if (resultData.userErrors && resultData.userErrors.length) {
        resultData.userErrors.forEach(function(item) {
          if (!item || !item.message) return;
          messages.push(String(item.message));
        });
      }

      if (!messages.length) return null;

      combinedMessage = messages.join(' | ').toLowerCase();

      if (combinedMessage.indexOf('phone has already been taken') !== -1) {
        return 'This phone number is already linked to another customer. Try a different number.';
      }

      if (combinedMessage.indexOf('phone is invalid') !== -1 || combinedMessage.indexOf('phone must be') !== -1) {
        return 'We saved your email, but we could not save that phone number. Check the number and try again.';
      }

      return null;
    }

    function getPathWithSearch() {
      return window.location.pathname + window.location.search;
    }

    function getCleanPathWithSearch() {
      var url;

      try {
        url = new URL(window.location.href);
      } catch (error) {
        return getPathWithSearch();
      }

      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
      }

      return url.pathname + url.search;
    }

    function hasPostedQuery() {
      var url;

      try {
        url = new URL(window.location.href);
      } catch (error) {
        return window.location.search.indexOf('customer_posted=true') !== -1;
      }

      return url.searchParams.get('customer_posted') === 'true';
    }

    function cleanPostedUrl() {
      var url;
      var hasChanges = false;

      try {
        url = new URL(window.location.href);
      } catch (error) {
        return;
      }

      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        hasChanges = true;
      }

      if (url.hash) {
        url.hash = '';
        hasChanges = true;
      }

      if (hasChanges) {
        history.replaceState({}, '', url.pathname + url.search);
      }
    }

    function saveSubmitContext() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      writeSessionStorage(pathStorageKey, getPathWithSearch());
      writeSessionStorage(scrollStorageKey, String(scrollY));
    }

    function getBackendSyncPayload() {
      var emailValue = '';
      var phoneValue = '';
      var hasConsent = false;

      if (emailInput) {
        emailValue = (emailInput.value || '').trim().toLowerCase();
      }

      if (phoneInput) {
        if (hasMeaningfulPhoneValue()) {
          phoneValue = getPhoneValue();
        }
      }

      if (consentInput) {
        hasConsent = consentInput.checked === true;
      }

      if (!emailValue) return null;

      return {
        email: emailValue,
        phone: phoneValue,
        countryIso: countryIso,
        emailConsent: hasConsent,
        smsConsent: hasConsent && phoneValue !== '',
        source: 'discount-newsletter',
        submitAction: submitIntent || (submitActionField ? submitActionField.value || '' : '')
      };
    }

    function saveBackendSyncPayload() {
      var payload;

      if (!backendEndpointUrl) return;

      payload = getBackendSyncPayload();
      if (!payload) return;

      clearSyncDebugStatus();

      try {
        writeSessionStorage(backendSyncPayloadKey, JSON.stringify(payload));
      } catch (error) {
        // Ignore payload storage errors.
      }

      return payload;
    }

    function clearBackendSyncPayload() {
      removeSessionStorage(backendSyncPayloadKey);
    }

    function getBackendSyncSignature(payload) {
      if (!payload) return '';
      return [payload.email || '', payload.phone || '', payload.submitAction || ''].join('|');
    }

    function maybeSyncPhoneToBackend() {
      var payload;
      var signature;
      var customerNotice = null;

      if (!backendEndpointUrl) return;
      if (designMode) return;
      if (!successStateMarker) return;
      if (isBackendSyncRequestPending) return;

      payload = readJsonSessionStorage(backendSyncPayloadKey);
      if (!payload || !payload.email) return;
      if (!payload.phone) return;

      signature = getBackendSyncSignature(payload);
      if (signature !== '' && readSessionStorage(backendSyncLastSuccessKey) === signature) {
        clearBackendSyncPayload();
        clearSyncDebugStatus();
        return;
      }

      isBackendSyncRequestPending = true;

      var guard = window.VeeseSignupGuard;
      var tokenRequest = guard ? guard.getToken() : Promise.reject(new Error('Signup guard missing'));

      tokenRequest
      .then(function(token) {
        return window.fetch(backendEndpointUrl, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(Object.assign({}, payload, { turnstileToken: token }))
        });
      })
      .then(function(response) {
        return response.json()
        .catch(function() {
          return null;
        })
        .then(function(data) {
          return {
            ok: response.ok,
            data: data
          };
        });
      })
      .then(function(result) {
        if (!result || result.ok !== true || !result.data || result.data.ok !== true) {
          customerNotice = getBackendSyncCustomerNotice(result ? result.data : null);
          if (customerNotice) {
            writeSyncDebugStatus(customerNotice, 'error');
          }
          return;
        }

        if (signature !== '') {
          writeSessionStorage(backendSyncLastSuccessKey, signature);
        }
        clearBackendSyncPayload();
        clearSyncDebugStatus();
      })
      .catch(function() {
        // Ignore transient request failures to avoid confusing customer-facing messaging.
      })
      .then(function() {
        isBackendSyncRequestPending = false;
      });
    }

    function clearSubmitContext() {
      removeSessionStorage(pathStorageKey);
      removeSessionStorage(scrollStorageKey);
    }

    function updateDiscountCodeLinkHref() {
      var baseUrl;
      var redirectPath;

      if (!discountCodeLink) return;

      baseUrl = discountCodeLink.getAttribute('data-discount-code-base-url') || '';
      if (baseUrl === '') return;

      redirectPath = getCleanPathWithSearch();
      if (!redirectPath || redirectPath === '') {
        redirectPath = window.location.pathname || '/';
      }

      discountCodeLink.setAttribute('href', baseUrl + '?redirect=' + encodeURIComponent(redirectPath));
    }

    function restoreScrollIfNeeded() {
      var savedPath = readSessionStorage(pathStorageKey);
      var savedY = readSessionStorage(scrollStorageKey);
      var y;

      if (!savedPath || savedY == null) return false;
      if (savedPath !== getCleanPathWithSearch()) return false;

      y = parseInt(savedY, 10);
      if (isNaN(y)) return false;

      window.scrollTo(0, y);
      window.requestAnimationFrame(function() {
        window.scrollTo(0, y);
      });
      window.setTimeout(function() {
        window.scrollTo(0, y);
      }, 120);

      clearSubmitContext();
      return true;
    }

    function isDismissed() {
      return readSessionStorage(dismissKey) === 'true';
    }

    function isTagAutoHidden() {
      return readSessionStorage(tagAutoHiddenKey) === 'true';
    }

    function setTagAutoHidden() {
      writeSessionStorage(tagAutoHiddenKey, 'true');
    }

    function hasCartPromptShown() {
      var persistedValue = readPersistentStorage(cartPromptShownKey);
      var sessionValue;

      if (persistedValue === 'true') {
        return true;
      }

      sessionValue = readSessionStorage(cartPromptShownKey);
      if (sessionValue === 'true') {
        writePersistentStorage(cartPromptShownKey, 'true');
        return true;
      }

      return false;
    }

    function setCartPromptShown() {
      writePersistentStorage(cartPromptShownKey, 'true');
      writeSessionStorage(cartPromptShownKey, 'true');
    }

    function hasCartPromptPending() {
      return readSessionStorage(cartPromptPendingKey) === 'true';
    }

    function setCartPromptPending() {
      writeSessionStorage(cartPromptPendingKey, 'true');
    }

    function clearCartPromptPending() {
      removeSessionStorage(cartPromptPendingKey);
    }

    function writeCartCount(count) {
      writeSessionStorage(cartCountSessionKey, String(count));
    }

    function clearTagAutoHideTimer() {
      if (tagAutoHideTimer) {
        window.clearTimeout(tagAutoHideTimer);
        tagAutoHideTimer = null;
      }
    }

    function clearCartPromptOpenTimer() {
      if (cartPromptOpenTimer) {
        window.clearTimeout(cartPromptOpenTimer);
        cartPromptOpenTimer = null;
      }

      isCartPromptQueued = false;
    }

    function clearCartCountSyncTimer() {
      if (cartCountSyncTimer) {
        window.clearTimeout(cartCountSyncTimer);
        cartCountSyncTimer = null;
      }
    }

    function closeAndSuppressConnectSocialDrawer() {
      var connectDrawerRoot = document.querySelector('[data-connect-social-drawer]');
      var connectDrawerSheet;
      var connectDrawerShownKey;

      if (!connectDrawerRoot) return;

      connectDrawerShownKey = connectDrawerRoot.getAttribute('data-shown-key');
      if (connectDrawerShownKey) {
        writeSessionStorage(connectDrawerShownKey, 'true');
      }

      if (!connectDrawerRoot.classList.contains('is-open')) return;

      connectDrawerRoot.classList.remove('is-open');
      connectDrawerSheet = connectDrawerRoot.querySelector('[data-connect-social-sheet]');
      if (connectDrawerSheet) {
        connectDrawerSheet.setAttribute('aria-hidden', 'true');
      }
    }

    function isCartAddAction(action) {
      if (!action) return false;
      return action.indexOf('/cart/add') !== -1;
    }

    function getRequestUrlString(requestInput) {
      if (!requestInput) return '';
      if (typeof requestInput === 'string') return requestInput;
      if (typeof requestInput.url === 'string') return requestInput.url;
      return '';
    }

    function installCartAddFetchObserver() {
      var nativeFetch;

      if (typeof window.fetch !== 'function') return;
      if (window.__discountNewsletterCartFetchObserved === true) return;

      nativeFetch = window.fetch;
      window.__discountNewsletterCartFetchObserved = true;

      window.fetch = function() {
        var requestUrl = getRequestUrlString(arguments[0]);
        var requestUrlLower = requestUrl.toLowerCase();
        var isCartAddRequest = isCartAddAction(requestUrlLower);
        var result = nativeFetch.apply(this, arguments);

        if (!isCartAddRequest || !result || typeof result.then !== 'function') {
          return result;
        }

        return result.then(function(response) {
          if (response && response.ok) {
            scheduleCartCountSyncCheck(850);
          }
          return response;
        });
      };
    }

    function syncCartCountAndMaybePrompt() {
      if (typeof window.fetch !== 'function') return;
      if (hasCartPromptShown()) return;
      if (designMode) return;

      window.fetch('/cart.js', {
        credentials: 'same-origin'
      })
      .then(function(response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function(cart) {
        var nextCount;
        var previousCount;

        if (!cart || typeof cart.item_count === 'undefined') return;

        nextCount = parseInt(cart.item_count, 10);
        if (isNaN(nextCount)) return;

        previousCount = lastKnownCartItemCount;
        lastKnownCartItemCount = nextCount;
        currentCartItemCount = nextCount;
        writeCartCount(nextCount);

        if (nextCount > previousCount) {
          queueCartPromptOpen({ ignoreDismiss: true });
        }
      })
      .catch(function() {
        // Ignore cart sync errors.
      });
    }

    function scheduleCartCountSyncCheck(delayMs) {
      if (hasCartPromptShown()) return;
      clearCartCountSyncTimer();

      cartCountSyncTimer = window.setTimeout(function() {
        cartCountSyncTimer = null;
        syncCartCountAndMaybePrompt();
      }, typeof delayMs === 'number' ? delayMs : 900);
    }

    function revealTab() {
      if (hideForSession && isDismissed()) return;
      if (!designMode && isTagAutoHidden()) return;
      clearTagAutoHideTimer();
      root.classList.add('is-tab-visible');
      if (isInstagramManualMode) {
        showInstagramDockedTab();
      }

      if (designMode) return;

      if (tabAutoHideSeconds > 0) {
        tagAutoHideTimer = window.setTimeout(function() {
          if (!root.classList.contains('is-tab-visible')) return;
          if (root.classList.contains('is-open')) return;
          setTagAutoHidden();
          hideTab(false);
        }, Math.round(tabAutoHideSeconds * 1000));
      }
    }

    function hideTab(persistDismissal) {
      clearTagAutoHideTimer();

      if (persistDismissal !== false && hideForSession) {
        writeSessionStorage(dismissKey, 'true');
      }

      root.classList.remove('is-tab-visible');
      if (isInstagramManualMode) {
        hideInstagramDockedTab();
      }
    }

    function getPhoneValue() {
      if (!phoneInput) return '';
      return (phoneInput.value || '').trim();
    }

    function getDialCodeForCountry(isoCode) {
      var dialCodeMap = {
        AE: '+971',
        AU: '+61',
        AT: '+43',
        BE: '+32',
        BR: '+55',
        CA: '+1',
        CH: '+41',
        CN: '+86',
        DE: '+49',
        DK: '+45',
        ES: '+34',
        FI: '+358',
        FR: '+33',
        GB: '+44',
        HK: '+852',
        IE: '+353',
        IL: '+972',
        IN: '+91',
        IT: '+39',
        JP: '+81',
        KR: '+82',
        MX: '+52',
        NL: '+31',
        NO: '+47',
        NZ: '+64',
        PT: '+351',
        SA: '+966',
        SE: '+46',
        SG: '+65',
        TR: '+90',
        US: '+1',
        ZA: '+27'
      };

      if (!isoCode) return '+1';
      return dialCodeMap[String(isoCode).toUpperCase()] || '+1';
    }

    function getPhonePrefillDialCode() {
      return getDialCodeForCountry(countryIso);
    }

    function normalizePhoneComparable(value) {
      return String(value || '').trim().replace(/[^+\d]/g, '');
    }

    function hasMeaningfulPhoneValue() {
      var value;
      var normalizedValue;
      var normalizedDialCode;

      if (!phoneInput) return false;

      value = getPhoneValue();
      if (value === '') return false;

      normalizedValue = normalizePhoneComparable(value);
      normalizedDialCode = normalizePhoneComparable(getPhonePrefillDialCode());

      if (normalizedValue === '' || normalizedValue === normalizedDialCode) {
        return false;
      }

      return true;
    }

    function ensurePhoneCountryCodePrefill() {
      var dialCode;

      if (!phoneInput) return;
      if (hasMeaningfulPhoneValue()) return;

      dialCode = getPhonePrefillDialCode();
      if (!dialCode) return;

      phoneInput.value = dialCode + ' ';
    }

    function setSubmitIntent(intent) {
      submitIntent = intent || '';
      if (submitActionField) {
        submitActionField.value = submitIntent;
      }
    }

    function updateRevealButtonState() {
      var hasPhone;

      if (!revealSubmitButton) return;
      if (!phoneInput) {
        revealSubmitButton.setAttribute('aria-disabled', 'false');
        return;
      }

      hasPhone = hasMeaningfulPhoneValue();
      revealSubmitButton.setAttribute('aria-disabled', hasPhone ? 'false' : 'true');

      if (hasPhone && revealErrorMessage) {
        revealErrorMessage.hidden = true;
      }
    }

    function triggerRevealPhoneError() {
      if (revealErrorMessage) {
        revealErrorMessage.hidden = false;
      }

      if (revealSubmitButton) {
        revealSubmitButton.classList.remove('is-bump');
        window.requestAnimationFrame(function() {
          revealSubmitButton.classList.add('is-bump');
          window.setTimeout(function() {
            revealSubmitButton.classList.remove('is-bump');
          }, 380);
        });
      }
    }

    function setStep(stepNumber, shouldFocus) {
      var focusTarget = null;
      var normalizedStep = stepNumber === 2 ? 2 : 1;
      var previewText = '';

      if (!stepOne || !stepTwo) return;

      stepOne.classList.toggle('is-active', normalizedStep === 1);
      stepTwo.classList.toggle('is-active', normalizedStep === 2);
      if (normalizedStep === 2) {
        ensurePhoneCountryCodePrefill();
      }
      updateRevealButtonState();

      if (emailPreview) {
        if (emailInput) {
          previewText = (emailInput.value || '').trim();
        }

        emailPreview.textContent = previewText;
        emailPreview.hidden = previewText === '';
      }

      if (shouldFocus === false || !panel) return;

      if (normalizedStep === 1) {
        focusTarget = panel.querySelector('[data-discount-email]');
      } else {
        focusTarget = panel.querySelector('[data-discount-phone]');
        if (!focusTarget) {
          focusTarget = panel.querySelector('.discount-newsletter__consent input');
        }
        if (!focusTarget) {
          focusTarget = panel.querySelector('button[type="submit"]');
        }
      }

      if (focusTarget) {
        focusTarget.focus();
      }
    }

    function applyInitialStep() {
      if (!stepOne || !stepTwo) return;

      if (hasServerErrors) {
        setStep(2, false);
        return;
      }

      setStep(1, false);
    }

    function openSheet(shouldFocus) {
      if (isInstagramManualMode) {
        var hasNewsletterState = root.querySelector('[data-newsletter-has-state]') !== null;
        if (!instagramManualOpenIntent && !hasNewsletterState) {
          return;
        }
        instagramManualOpenIntent = false;
        hideInstagramDockedTab();
      }

      if (isCartPromptQueued || hasCartPromptPending()) {
        setCartPromptShown();
        clearCartPromptPending();
      }

      clearTagAutoHideTimer();
      clearCartPromptOpenTimer();
      clearCartCountSyncTimer();
      closeAndSuppressConnectSocialDrawer();
      applyInitialStep();
      root.classList.add('is-open');
      if (sheet) {
        sheet.setAttribute('aria-hidden', 'false');
      }

      if (shouldFocus === false || !panel) return;

      if (stepOne && stepTwo) {
        if (hasServerErrors) {
          setStep(2, true);
          return;
        }

        setStep(1, true);
        return;
      }

      var focusTarget = panel.querySelector(
        'input:not([type="hidden"]):not([disabled]), button:not([disabled]), a[href], select:not([disabled]), textarea:not([disabled])'
      );

      if (focusTarget) {
        focusTarget.focus();
      }
    }

    function closeSheet(restoreFocus) {
      root.classList.remove('is-open');
      if (sheet) {
        sheet.setAttribute('aria-hidden', 'true');
      }

      if (!hasServerErrors) {
        setStep(1, false);
      }

      if (isInstagramManualMode) {
        if (root.classList.contains('is-tab-visible')) {
          showInstagramDockedTab();
        } else {
          hideInstagramDockedTab();
        }
      }

      if (restoreFocus === false) return;
      if (activeTrigger && typeof activeTrigger.focus === 'function') {
        activeTrigger.focus();
      }
    }

    function canQueueCartPrompt(options) {
      var ignoreDismiss = options && options.ignoreDismiss === true;

      if (hasCartPromptShown()) return false;
      if (designMode) return false;
      if (!ignoreDismiss && hideForSession && isDismissed()) return false;
      if (root.classList.contains('is-open')) return false;
      if (root.querySelector('[data-newsletter-has-state]')) return false;
      return true;
    }

    function queueCartPromptOpen(options) {
      var queueOptions = options || {};
      var ignoreDismiss = queueOptions.ignoreDismiss === true;

      if (disableAutoPrompts) return;
      if (!canQueueCartPrompt(queueOptions)) return;
      if (isCartPromptQueued) return;
      clearCartPromptOpenTimer();
      setCartPromptPending();
      isCartPromptQueued = true;
      cartPromptOpenTimer = window.setTimeout(function() {
        cartPromptOpenTimer = null;
        isCartPromptQueued = false;

        if (!ignoreDismiss && hideForSession && isDismissed()) {
          clearCartPromptPending();
          return;
        }
        if (root.classList.contains('is-open')) {
          setCartPromptShown();
          clearCartPromptPending();
          return;
        }

        setCartPromptShown();
        clearCartPromptPending();
        hideTab(false);
        openSheet(false);
      }, cartPromptDelayMs);
    }

    function handleCartUpdated(event) {
      var cartDetail = event && event.detail ? event.detail : null;
      var nextCount;
      var previousCount;
      var countIncreased;
      var looksLikeAddToCart;

      if (!cartDetail || typeof cartDetail.item_count === 'undefined') return;

      nextCount = parseInt(cartDetail.item_count, 10);
      if (isNaN(nextCount)) return;

      previousCount = lastKnownCartItemCount;
      countIncreased = nextCount > previousCount;
      looksLikeAddToCart = cartDetail.animate === true || countIncreased;
      lastKnownCartItemCount = nextCount;
      writeCartCount(nextCount);

      if (!looksLikeAddToCart) return;
      queueCartPromptOpen({ ignoreDismiss: true });
    }

    function handleDirectCartAddTrigger(event) {
      var cartDetail = event && event.detail ? event.detail : null;

      if (cartDetail && typeof cartDetail.item_count !== 'undefined') {
        if (cartDetail.animate !== true) {
          cartDetail.animate = true;
        }
        handleCartUpdated({ detail: cartDetail });
        return;
      }

      queueCartPromptOpen({ ignoreDismiss: true });
    }

    function getFocusableElements() {
      if (!panel) return [];

      return Array.prototype.slice.call(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
    }

    function handleTabKey(event) {
      var focusable;
      var first;
      var last;

      if (event.key !== 'Tab') return;
      if (!root.classList.contains('is-open')) return;

      focusable = getFocusableElements();
      if (!focusable.length) return;

      first = focusable[0];
      last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
        return;
      }

      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    if (phoneInput) {
      ensurePhoneCountryCodePrefill();

      phoneInput.addEventListener('input', function() {
        phoneInput.setCustomValidity('');
        phoneInput.removeAttribute('aria-invalid');
        clearSyncDebugStatus();
        updateRevealButtonState();
      });

      phoneInput.addEventListener('focus', function() {
        if (!hasMeaningfulPhoneValue()) {
          ensurePhoneCountryCodePrefill();
        }
      });

      phoneInput.addEventListener('invalid', function() {
        phoneInput.setCustomValidity(phoneInvalidMessage);
      });
    }

    updateRevealButtonState();
    restoreSyncDebugStatus();

    if (revealSubmitButton) {
      revealSubmitButton.addEventListener('click', function(event) {
        if (!form) return;

        event.preventDefault();
        setSubmitIntent('reveal');

        if (phoneInput && !hasMeaningfulPhoneValue()) {
          phoneInput.setCustomValidity(revealNeedsPhoneMessage);
          if (typeof phoneInput.reportValidity === 'function') {
            phoneInput.reportValidity();
          }
          phoneInput.setAttribute('aria-invalid', 'true');
          triggerRevealPhoneError();
          phoneInput.focus();
          setSubmitIntent('');
          return;
        }

        if (phoneInput) {
          phoneInput.setCustomValidity('');
          phoneInput.removeAttribute('aria-invalid');
        }

        if (typeof form.requestSubmit === 'function') {
          if (skipSubmitButton) {
            form.requestSubmit(skipSubmitButton);
          } else {
            form.requestSubmit();
          }
        } else {
          if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            return;
          }
          saveSubmitContext();
          saveBackendSyncPayload();
          form.submit();
        }
      });
    }

    if (skipSubmitButton) {
      skipSubmitButton.addEventListener('click', function() {
        setSubmitIntent('skip');
      });
    }

    if (form) {
      form.addEventListener('submit', function(event) {
        var submitter = event.submitter || document.activeElement;
        var isSkipSubmit = submitter && submitter.matches && submitter.matches('[data-discount-submit-skip]');

        if (event.defaultPrevented) return;

        if (!isSkipSubmit && submitIntent === 'skip') {
          isSkipSubmit = true;
        }

        if (phoneInput && stepTwo && stepTwo.classList.contains('is-active')) {
          if (!hasMeaningfulPhoneValue()) {
            if (isSkipSubmit) {
              if (phoneInput) {
                phoneInput.value = '';
                phoneInput.setCustomValidity('');
                phoneInput.removeAttribute('aria-invalid');
              }
              setSubmitIntent('');
              if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
              saveSubmitContext();
              saveBackendSyncPayload();
              return;
            }

            event.preventDefault();
            phoneInput.setCustomValidity(revealNeedsPhoneMessage);
            if (typeof phoneInput.reportValidity === 'function') {
              phoneInput.reportValidity();
            }
            phoneInput.setAttribute('aria-invalid', 'true');
            triggerRevealPhoneError();
            phoneInput.focus();
            setSubmitIntent('');
            return;
          }

          phoneInput.setCustomValidity('');
        }

        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

        saveSubmitContext();
        /* Synced after the native submit reloads the page (maybeSyncPhoneToBackend),
           where there's time to fetch a single-use Turnstile token. */
        saveBackendSyncPayload();
        setSubmitIntent('');
      });
    }

    if (discountCodeLink) {
      discountCodeLink.addEventListener('click', function() {
        updateDiscountCodeLinkHref();
        saveSubmitContext();
      });
    }

    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        closeSheet(true);
      });
    });

    dismissButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        hideTab();
        closeSheet(false);
      });
    });

    document.addEventListener('click', function(event) {
      var openTarget = event.target.closest('[data-discount-open], [data-newsletter-open]');
      var closeTarget = event.target.closest('[data-discount-close]');
      var dismissTarget = event.target.closest('[data-discount-dismiss]');
      var snoozeTarget = event.target.closest('[data-discount-snooze]');
      var nextTarget = event.target.closest('[data-discount-next]');
      var backTarget = event.target.closest('[data-discount-back]');

      if (nextTarget && root.contains(nextTarget)) {
        event.preventDefault();
        if (!emailInput) return;
        emailInput.setCustomValidity('');

        if (typeof emailInput.checkValidity === 'function' && !emailInput.checkValidity()) {
          if (typeof emailInput.reportValidity === 'function') {
            emailInput.reportValidity();
          }
          return;
        }

        setStep(2, true);
        return;
      }

      if (backTarget && root.contains(backTarget)) {
        event.preventDefault();
        setStep(1, true);
        return;
      }

      if (closeTarget && root.contains(closeTarget)) {
        event.preventDefault();
        closeSheet(true);
        return;
      }

      if (dismissTarget && root.contains(dismissTarget)) {
        event.preventDefault();
        hideTab();
        closeSheet(false);
        return;
      }

      if (snoozeTarget && root.contains(snoozeTarget)) {
        event.preventDefault();
        if (hideForSession) {
          hideTab();
        }
        closeSheet(false);
        return;
      }

      if (!openTarget) return;

      event.preventDefault();
      if (isInstagramManualMode) {
        instagramManualOpenIntent = true;
      }
      if (root.contains(openTarget) && openTarget.matches('[data-discount-open]')) {
        if (!isInstagramManualMode) {
          setTagAutoHidden();
          hideTab(false);
        }
      }
      activeTrigger = openTarget;
      openSheet(true);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        event.preventDefault();
        closeSheet(true);
        return;
      }

      handleTabKey(event);
    });

    if (!disableAutoPrompts) {
      document.addEventListener('submit', function(event) {
        var formEl = event.target;
        var action = '';

        if (!formEl || !formEl.tagName || formEl.tagName.toLowerCase() !== 'form') return;
        action = (formEl.getAttribute('action') || '').toLowerCase();
        if (!isCartAddAction(action)) return;

        scheduleCartCountSyncCheck(1000);
      }, true);

      document.addEventListener('click', function(event) {
        var target = event.target;
        var addToCartButton;
        var formEl;
        var action = '';

        if (!target || typeof target.closest !== 'function') return;

        addToCartButton = target.closest('[data-add-to-cart]');
        if (!addToCartButton) return;

        formEl = addToCartButton.closest('form');
        if (!formEl) return;

        action = (formEl.getAttribute('action') || '').toLowerCase();
        if (!isCartAddAction(action)) return;

        scheduleCartCountSyncCheck(1200);
      }, true);

      document.addEventListener('cart:updated', handleCartUpdated);
      document.addEventListener('discount-newsletter:cart-add', handleDirectCartAddTrigger);
      installCartAddFetchObserver();
    }

    window.__discountNewsletterQueueCartPrompt = function() {
      if (disableAutoPrompts) return;
      queueCartPromptOpen({ ignoreDismiss: true });
    };

    applyInitialStep();
    updateDiscountCodeLinkHref();

    if (!disableAutoPrompts) {
      if (hasCartPromptShown()) {
        clearCartPromptPending();
      }

      if (!hasCartPromptShown()) {
        if (hasCartPromptPending()) {
          queueCartPromptOpen({ ignoreDismiss: true });
        } else if (hasStoredCartCount && currentCartItemCount > lastKnownCartItemCount) {
          queueCartPromptOpen({ ignoreDismiss: true });
        }
      }
    } else {
      clearCartPromptPending();
    }

    writeCartCount(currentCartItemCount);

    if (root.querySelector('[data-newsletter-has-state]')) {
      restoreScrollIfNeeded();
      cleanPostedUrl();
      openSheet(false);
      maybeSyncPhoneToBackend();
    } else if (hasPostedQuery()) {
      cleanPostedUrl();
      restoreScrollIfNeeded();
    } else {
      clearSubmitContext();

      if (designMode) {
        revealTab();
      } else {
        window.setTimeout(function() {
          revealTab();
        }, delaySeconds * 1000);
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["notify-me-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    var modal = document.querySelector('[data-notify-modal]');
    if (!modal) return;

    var closeButtons = modal.querySelectorAll('[data-notify-close]');
    var form = modal.querySelector('[data-notify-form]') || modal.querySelector('form');
    var emailInput = modal.querySelector('[data-notify-email]');
    var consentInput = modal.querySelector('[data-notify-consent]');
    var productNameEl = modal.querySelector('[data-notify-product-name]');
    var successEl = modal.querySelector('[data-notify-success]');
    var errorEl = modal.querySelector('[data-notify-error]');
    var endpoint = modal.dataset.notifyEndpoint;
    var shopDomain = modal.dataset.notifyShopDomain || '';
    var submitButton = form ? form.querySelector('.notify-modal__submit') : null;
    var initialEmailValue = emailInput ? emailInput.value : '';
    var sizeWrap = modal.querySelector('[data-notify-size-wrap]');
    var sizeSelect = modal.querySelector('[data-notify-size]');

    function readProductJson() {
      var productJsonScript = document.querySelector('[data-product-json]');
      if (!productJsonScript) return null;

      try {
        return JSON.parse(productJsonScript.textContent);
      } catch (_err) {
        return null;
      }
    }

    function getSelectedVariant(productData) {
      if (!productData || !productData.variants || !productData.variants.length) return null;

      var variantInput = document.querySelector('[data-variant-id]');
      var variantIdValue = variantInput && variantInput.value ? String(variantInput.value) : '';
      if (!variantIdValue) return null;

      for (var i = 0; i < productData.variants.length; i += 1) {
        if (String(productData.variants[i].id) === variantIdValue) {
          return productData.variants[i];
        }
      }

      return null;
    }

    function getSizeOptionIndex(productData) {
      if (!productData || !productData.options) return -1;

      for (var i = 0; i < productData.options.length; i += 1) {
        var name = productData.options[i] && productData.options[i].name
          ? productData.options[i].name.toLowerCase()
          : '';
        if (name.indexOf('size') !== -1) return i;
      }

      return -1;
    }

    function getVariantForSize(productData, sizeIndex, sizeValue) {
      if (!productData || !productData.variants) return null;

      return productData.variants.find(function(variant) {
        return productData.options.every(function(option, index) {
          var expected = index === sizeIndex ? sizeValue : option.selected_value;
          return variant['option' + (index + 1)] === expected;
        });
      }) || null;
    }

    function populateSizeSelect(productData, sizeIndex) {
      if (!sizeSelect) return;

      sizeSelect.innerHTML = '';

      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = sizeSelect.dataset.placeholder || 'Select size';
      placeholder.disabled = true;
      placeholder.selected = true;
      sizeSelect.appendChild(placeholder);

      var values = productData.options[sizeIndex].values || [];
      values.forEach(function(value) {
        var variant = getVariantForSize(productData, sizeIndex, value);
        if (!variant) return;
        var optionEl = document.createElement('option');
        optionEl.value = String(variant.id);
        optionEl.textContent = value;
        sizeSelect.appendChild(optionEl);
      });
    }

    function prepareSizeField() {
      if (!sizeWrap || !sizeSelect) return;

      var productData = readProductJson();
      var sizeIndex = getSizeOptionIndex(productData);
      var selectedVariant = getSelectedVariant(productData);

      if (!selectedVariant && sizeIndex !== -1) {
        populateSizeSelect(productData, sizeIndex);
        sizeSelect.required = true;
        sizeWrap.hidden = false;
      } else {
        sizeSelect.required = false;
        sizeWrap.hidden = true;
      }
    }

    function openModal(button) {
      var title = '';
      var url = '';
      var handle = 'unknown';

      if (productNameEl) {
        if (button) {
          title = button.dataset.productTitle || '';
          url = button.dataset.productUrl || '';
          handle = button.dataset.productHandle || 'unknown';
        }
        productNameEl.textContent = title || productNameEl.textContent || '';
      }

      prepareSizeField();

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (successEl) successEl.hidden = true;

      if (sizeWrap && !sizeWrap.hidden && sizeSelect) {
        sizeSelect.focus();
      } else if (emailInput) {
        emailInput.focus();
      }
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('click', function(e) {
      var button = e.target.closest('[data-notify-open]');
      if (!button) return;
      e.preventDefault();
      openModal(button);
    });

    if (form) {
      function readVariantStockJson() {
        var stockJsonScript = document.querySelector('[data-variant-stock-json]');
        if (!stockJsonScript) return null;

        try {
          return JSON.parse(stockJsonScript.textContent);
        } catch (_err) {
          return null;
        }
      }

      function getErrorMessage(err) {
        if (!err) return 'Something went wrong. Please try again.';
        if (typeof err === 'string') return err;
        if (err.error) return err.error;
        if (err.message) return err.message;
        return 'Something went wrong. Please try again.';
      }

      form.setAttribute('data-notify-form', '');
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!endpoint) return;

        if (form && !form.checkValidity()) {
          form.reportValidity();
          return;
        }

        var button = document.querySelector('[data-notify-open][data-mode="notify"]');
        var title = button ? (button.dataset.productTitle || '') : '';
        var url = button ? (button.dataset.productUrl || '') : '';
        var handle = button ? (button.dataset.productHandle || '') : '';
        var variantInput = document.querySelector('[data-variant-id]');
        var variantId = variantInput && variantInput.value ? String(variantInput.value) : '';
        var productData = readProductJson();
        var selectedVariant = getSelectedVariant(productData);

        if (!selectedVariant && sizeWrap && !sizeWrap.hidden && sizeSelect && sizeSelect.value) {
          selectedVariant = (productData && productData.variants || []).find(function(variant) {
            return String(variant.id) === sizeSelect.value;
          }) || null;
        }

        var variantStockData = readVariantStockJson();
        var productId = productData && productData.id ? String(productData.id) : '';
        var variantTitle = '';
        var productTitle = title;
        var productUrl = window.location.href.split('#')[0];
        var inventoryItemId = '';

        if (productData && productData.title) {
          productTitle = productData.title;
        }

        if (selectedVariant) {
          variantId = String(selectedVariant.id);
          variantTitle = selectedVariant.name || selectedVariant.title || '';
        }

        if (variantId && variantStockData && variantStockData[variantId]) {
          var stockRow = variantStockData[variantId];
          if (stockRow && stockRow.inventory_item_id != null && stockRow.inventory_item_id !== '') {
            inventoryItemId = String(stockRow.inventory_item_id);
          }
        }

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        if (successEl) successEl.hidden = true;

        if (!variantId) {
          if (errorEl) {
            errorEl.textContent = 'Please select a size before requesting a back-in-stock alert.';
            errorEl.hidden = false;
          }
          return;
        }

        var payload = {
          email: emailInput ? emailInput.value.trim() : '',
          emailConsent: consentInput ? consentInput.checked : false,
          consent: consentInput ? consentInput.checked : false,
          shopDomain: shopDomain,
          productId: productId,
          variantId: variantId,
          inventoryItemId: inventoryItemId,
          productTitle: productTitle,
          variantTitle: variantTitle,
          productUrl: productUrl,
          product_handle: handle,
          product_url: productUrl || url,
          product_title: productTitle,
          variant_id: variantId,
          inventory_item_id: inventoryItemId,
          website: form.querySelector('.notify-modal__honeypot') ? form.querySelector('.notify-modal__honeypot').value : ''
        };

        if (submitButton) submitButton.disabled = true;

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json()
            .catch(function() { return {}; })
            .then(function(data) {
              if (!response.ok) throw data;
              if (data && data.ok === false) throw data;
              return data;
            });
        })
        .then(function() {
          if (successEl) successEl.hidden = false;
          if (form) form.reset();
          if (emailInput && initialEmailValue) {
            emailInput.value = initialEmailValue;
          }
        })
        .catch(function(err) {
          if (errorEl) {
            errorEl.textContent = getErrorMessage(err);
            errorEl.hidden = false;
          }
        })
        .finally(function() {
          if (submitButton) submitButton.disabled = false;
        });
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    var activeCard = null;
    var isMobile = window.innerWidth < 750;

    function updateIsMobile() {
      isMobile = window.innerWidth < 750;
    }

    window.addEventListener('resize', updateIsMobile);

    function initProductCarousel(card) {
      if (card.dataset.carouselInitialized === 'true') return;

      var carouselImages = card.querySelector('[data-carousel-images]');
      var slides = card.querySelectorAll('.product-card__image-slide');
      var prevButton = card.querySelector('[data-carousel-prev]');
      var nextButton = card.querySelector('[data-carousel-next]');
      var dots = card.querySelectorAll('[data-carousel-dot]');
      var link = card.querySelector('[data-product-link]');

      if (!carouselImages || slides.length <= 1) {
        card.dataset.carouselInitialized = 'true';
        return;
      }

      var realSlideCount = slides.length;
      var currentIndex = 0;
      var trackIndex = 1;
      var pendingLoopResetIndex = null;
      var carouselViewport = card.querySelector('.product-card__carousel-container');
      var slideWidth = (
        (carouselViewport && carouselViewport.getBoundingClientRect().width) ||
        slides[0].getBoundingClientRect().width ||
        slides[0].offsetWidth
      );
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[realSlideCount - 1].cloneNode(true);

      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.setAttribute('data-carousel-clone', 'true');
      lastClone.setAttribute('data-carousel-clone', 'true');
      carouselImages.appendChild(firstClone);
      carouselImages.insertBefore(lastClone, carouselImages.firstChild);

      function setCarouselTrackPosition(nextTrackIndex, immediate) {
        var offset = -nextTrackIndex * slideWidth;

        if (immediate) {
          var previousTransition = carouselImages.style.transition;
          carouselImages.style.transition = 'none';
          carouselImages.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
          carouselImages.offsetWidth;
          carouselImages.style.transition = previousTransition;
          return;
        }

        carouselImages.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }

      function refreshCarouselMeasurements() {
        var nextSlideWidth = (
          (carouselViewport && carouselViewport.getBoundingClientRect().width) ||
          slides[0].getBoundingClientRect().width ||
          slides[0].offsetWidth
        );
        if (!nextSlideWidth || nextSlideWidth <= 0) return;

        slideWidth = nextSlideWidth;
        showSlide(currentIndex, { immediate: true });
      }

      function showSlide(index, options) {
        options = options || {};
        var requestedIndex = index;

        currentIndex = requestedIndex;
        if (currentIndex < 0) {
          currentIndex = realSlideCount - 1;
        } else if (currentIndex >= realSlideCount) {
          currentIndex = 0;
        }

        if (requestedIndex < 0) {
          trackIndex = 0;
          pendingLoopResetIndex = currentIndex;
        } else if (requestedIndex >= realSlideCount) {
          trackIndex = realSlideCount + 1;
          pendingLoopResetIndex = currentIndex;
        } else {
          trackIndex = currentIndex + 1;
          pendingLoopResetIndex = null;
        }

        setCarouselTrackPosition(trackIndex, options.immediate === true);

        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      carouselImages.addEventListener('transitionend', function(event) {
        if (event.target !== carouselImages) return;
        if (event.propertyName !== 'transform') return;
        if (pendingLoopResetIndex === null) return;

        trackIndex = pendingLoopResetIndex + 1;
        pendingLoopResetIndex = null;
        setCarouselTrackPosition(trackIndex, true);
      });

      showSlide(0, { immediate: true });
      requestAnimationFrame(refreshCarouselMeasurements);
      setTimeout(refreshCarouselMeasurements, 120);

      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showSlide(currentIndex - 1);
      });

      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showSlide(currentIndex + 1);
      });

      // Mobile: allow normal tap navigation unless a swipe just occurred.
      var suppressLinkClick = false;
      link.addEventListener('click', function(e) {
        if (!isMobile) return;
        if (suppressLinkClick) {
          e.preventDefault();
          e.stopPropagation();
          suppressLinkClick = false;
        }
      });

      // Touch swipe support for mobile (without requiring an active-card tap state)
      var touchStartX = 0;
      var touchStartY = 0;
      var touchEndX = 0;
      var touchEndY = 0;

      card.addEventListener('touchstart', function(e) {
        if (!e.changedTouches || !e.changedTouches.length) return;
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        touchEndX = touchStartX;
        touchEndY = touchStartY;
        suppressLinkClick = false;
      }, { passive: true });

      card.addEventListener('touchmove', function(e) {
        if (!e.changedTouches || !e.changedTouches.length) return;

        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;

        var diffX = touchStartX - touchEndX;
        var diffY = touchStartY - touchEndY;

        // Prevent vertical page scroll only when this is clearly a horizontal swipe.
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 8) {
          e.preventDefault();
        }
      }, { passive: false });

      card.addEventListener('touchend', function(e) {
        if (!e.changedTouches || !e.changedTouches.length) return;

        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        var diff = touchStartX - touchEndX;
        var diffY = touchStartY - touchEndY;

        if (Math.abs(diff) > 50 && Math.abs(diff) > Math.abs(diffY)) {
          e.preventDefault();
          suppressLinkClick = true;
          if (diff > 0) {
            showSlide(currentIndex + 1);
          } else {
            showSlide(currentIndex - 1);
          }
          setTimeout(function() {
            suppressLinkClick = false;
          }, 250);
        }
      }, { passive: false });

      window.addEventListener('resize', function() {
        refreshCarouselMeasurements();
      });

      if (typeof ResizeObserver !== 'undefined') {
        var media = card.querySelector('.product-card__media');
        if (media) {
          var resizeObserver = new ResizeObserver(function() {
            refreshCarouselMeasurements();
          });
          resizeObserver.observe(media);
        }
      }

      card.dataset.carouselInitialized = 'true';
    }

    function deactivateAllCards() {
      document.querySelectorAll('[data-product-card].is-active').forEach(function(card) {
        card.classList.remove('is-active');
      });
      activeCard = null;
    }

    // Click outside to deactivate
    document.addEventListener('click', function(e) {
      if (!isMobile) return;

      var clickedCard = e.target.closest('[data-product-card]');
      if (!clickedCard && activeCard) {
        deactivateAllCards();
      }
    });

    // Initialize carousels for existing product cards
    document.querySelectorAll('[data-product-card]').forEach(initProductCarousel);

    // Observe for new product cards added to the DOM
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.matches('[data-product-card]')) {
            initProductCarousel(node);
          }
          if (node.nodeType === 1 && node.querySelector) {
            node.querySelectorAll('[data-product-card]').forEach(initProductCarousel);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["signup-guard"] && !Shopify.designMode) return;
  try {
    (function() {
    var SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    var TOKEN_TIMEOUT_MS = 60000;
    var scriptPromise = null;

    function loadTurnstile() {
      if (window.turnstile) return Promise.resolve(window.turnstile);
      if (scriptPromise) return scriptPromise;

      scriptPromise = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = SCRIPT_URL;
        script.async = true;
        script.onload = function() {
          if (window.turnstile) {
            resolve(window.turnstile);
          } else {
            scriptPromise = null;
            reject(new Error('Turnstile unavailable'));
          }
        };
        script.onerror = function() {
          scriptPromise = null;
          reject(new Error('Turnstile script failed to load'));
        };
        document.head.appendChild(script);
      });

      return scriptPromise;
    }

    function getToken() {
      var host = document.querySelector('[data-signup-guard]');
      if (!host) return Promise.reject(new Error('Signup guard container missing'));

      return loadTurnstile().then(function(turnstile) {
        return new Promise(function(resolve, reject) {
          var slot = document.createElement('div');
          var widgetId = null;
          var settled = false;
          var timer;

          function finish(settle, value) {
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            try {
              if (widgetId !== null) turnstile.remove(widgetId);
            } catch (error) {
              /* Widget already gone — nothing to clean up. */
            }
            if (slot.parentNode) slot.parentNode.removeChild(slot);
            settle(value);
          }

          host.appendChild(slot);
          timer = window.setTimeout(function() {
            finish(reject, new Error('Turnstile timed out'));
          }, TOKEN_TIMEOUT_MS);

          widgetId = turnstile.render(slot, {
            sitekey: host.getAttribute('data-sitekey'),
            appearance: 'interaction-only',
            callback: function(token) {
              finish(resolve, token);
            },
            'error-callback': function(code) {
              finish(reject, new Error('Turnstile error ' + code));
              return true;
            },
            'expired-callback': function() {
              finish(reject, new Error('Turnstile token expired'));
            }
          });
        });
      });
    }

    window.VeeseSignupGuard = {
      getToken: getToken,
      /* Start the script download early (e.g. when a form opens) so submit is fast. */
      warm: function() {
        loadTurnstile().catch(function() {
          /* Retried on submit; failure surfaces there. */
        });
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
